/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppDeleteFragmentDetailByIdMutationResponse, WebAppDeleteFragmentDetailByIdPathParams, WebAppDeleteFragmentDetailById403, WebAppDeleteFragmentDetailById404 } from "../models/WebAppDeleteFragmentDetailById";

export function getWebAppDeleteFragmentDetailByIdUrl(id: WebAppDeleteFragmentDetailByIdPathParams["id"]) {
  const res = { method: 'DELETE', url: `/web-app/v1/fragments/${id}` as const }
  return res
}

/**
 * @summary Delete one fragment by id
 * {@link /web-app/v1/fragments/:id}
 */
export async function webAppDeleteFragmentDetailById(id: WebAppDeleteFragmentDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppDeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<WebAppDeleteFragmentDetailById403 | WebAppDeleteFragmentDetailById404>, unknown>({ method : "DELETE", url : getWebAppDeleteFragmentDetailByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}